import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// Sentry browser-side error tracking. No-op if REACT_APP_SENTRY_DSN is unset.
// To activate: sign up at sentry.io (free tier 5K errors/month), copy the
// React project DSN, set REACT_APP_SENTRY_DSN as a build-time arg in
// docker-compose.yml's frontend service, redeploy the frontend.
if (process.env.REACT_APP_SENTRY_DSN) {
  try {
    // Lazy import keeps the bundle smaller when Sentry isn't configured.
    // eslint-disable-next-line global-require
    const Sentry = require('@sentry/react');
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
      tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || '0.1'),
      // Session Replay deliberately OFF — privacy (records DOM/inputs) +
      // free-tier cost. Flip these on later only if you accept the trade-off
      // and have a Replay-enabled Sentry plan.
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0,
      ignoreErrors: [
        'ResizeObserver loop limit exceeded',
        'Non-Error promise rejection captured'
      ]
    });
    // eslint-disable-next-line no-console
    console.log('[Sentry] Frontend error tracking enabled');
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[Sentry] Init failed (non-fatal):', err.message);
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
